import { State, StateIdentifier } from './definition.state';
import { StateSelectArea } from './state.00.select.area';
import { StateSelectProduct } from './state.01.select.product';
import { StateSelectDataset } from './state.02.select.dataset';
// import { StateVerifyProceed } from './state.03.verify.proceed';



export class StateController {
    selectArea: StateSelectArea;
    selectProduct: StateSelectProduct; //  = stateSelectProduct;
    selectDataset: StateSelectDataset; //  = stateSelectProduct;
    // verifyProceed: StateVerifyProceed; //  = stateSelectProduct;


    constructor(node_application_container: HTMLDivElement) {
        this.selectArea = new StateSelectArea(node_application_container);
        this.selectProduct = new StateSelectProduct(node_application_container);
        this.selectDataset = new StateSelectDataset(node_application_container);
        // this.verifyProceed = new StateVerifyProceed(node_application_container);

        // this.verifyProceed.active = false;
        this.selectProduct.active = false;
        this.selectDataset.active = false;
        this.selectArea.active = true;
    }




    protected seState(id: StateIdentifier, initParameters: any) {
        if (id === 'select-area') {
            this.selectProduct.active = false;
            this.selectDataset.active = false;
            // this.verifyProceed.active = false;
            this.selectArea.activateAndInit(initParameters)
        }

        if (id === 'select-product') {
            this.selectArea.active = false;
            this.selectDataset.active = false;
            // this.verifyProceed.active = false;
            this.selectProduct.activateAndInit(initParameters)
        }

        if (id === 'select-dataset') {
            this.selectArea.active = false;
            this.selectProduct.active = false;
            // this.verifyProceed.active = false;
            this.selectDataset.activateAndInit(initParameters)
        }

        // if (id === 'verify-proceed') {
        //     this.selectArea.active = false;
        //     this.selectProduct.active = false;
        //     this.selectDataset.active = false;
        //     this.verifyProceed.activateAndInit(initParameters)
        // }
    }


    public attachStateToDomEvent(dom: HTMLDivElement, sourceStateId: StateIdentifier, targetStateId: StateIdentifier) {
        dom.addEventListener("click", () => {
            // console.log(targetStateId);
            if (sourceStateId === 'select-area') {
                this.seState(targetStateId, this.selectArea.passOverPrameters);
            }
            if (sourceStateId === 'select-product') {
                this.seState(targetStateId, this.selectProduct.passOverPrameters);
            }
            if (sourceStateId === 'select-dataset') {
                this.seState(targetStateId, this.selectDataset.passOverPrameters);
            }
            // if (sourceStateId === 'verify-proceed') {
            //     this.seState(targetStateId, this.verifyProceed.passOverPrameters);
            // }
            
        });
    }


    public dispose(){
        this.selectArea.dispose();
        this.selectProduct.dispose();
        this.selectDataset.dispose();
        // this.verifyProceed.dispose();
    }

}
